import Image from 'next/image';
import { memo } from 'react';
import './BirdLogo.module.scss';

type BirdLogoProps = {
    alt?: string;
    className?: string;
    dataTestId?: string;
};

const BirdLogoComponent = ({ alt = 'Chattenger logo', className, dataTestId }: BirdLogoProps) => (
    // <svg className={className} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    //     <path
    //         d="M12 36C12 22.7452 22.7452 12 36 12H40C43.3137 12 46 14.6863 46 18V21.5C46 24.8137 43.3137 27.5 40 27.5H34C29.3056 27.5 25.5 31.3056 25.5 36C25.5 40.6944 29.3056 44.5 34 44.5H52C52 51.9558 45.9558 58 38.5 58H34C21.8497 58 12 48.1503 12 36Z"
    //         fill="currentColor"
    //     />
    //     <circle cx="38" cy="20" r="2.6" fill="white" />
    // </svg>
    <Image alt={alt} className={className} data-testid={dataTestId} height={64} src="/branding/pigeon-logo.png" width={64} />
);

BirdLogoComponent.displayName = 'BirdLogo';

export const BirdLogo = memo(BirdLogoComponent);
